import { render, staticRenderFns } from "./BottomNavButton.vue?vue&type=template&id=5e19089b&"
import script from "./BottomNavButton.vue?vue&type=script&lang=js&"
export * from "./BottomNavButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports